@if (isNewGuestDropoffFlowEnabled) {
  <!-- New guest dropoff flow -->
  <lh-guest-feature-dropoff [storageLocation]="storageLocation"></lh-guest-feature-dropoff>
} @else {
  <!-- Old dropoff flow -->
  <div *ngIf="isLoading" class="spinner-container">
    <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
  </div>

  <lh-step-navigation [steps]="dropoffSteps"></lh-step-navigation>
}
